import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const CEILING = () => {
  return (
    <CardSection id="CEILING" title="CEILING">
      <Paragraph>주어진 숫자를 정수로 올림하여 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>CEILING(VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 올림하려는 값입니다.
          </Li>
        </Ul>
      </ListSection>
      <ListSection title="Example">
        <Paragraph accent>CEILING(`Column`)</Paragraph>
        <Img src="computeCeiling" />
      </ListSection>
      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 실수이거나, 실수를 포함하는 열이거나, 실수를
          반환하는 함수여야 합니다 .
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
